import React from 'react';
import { MainLayout } from 'layout/mainLayout';

import HeroTitle from '../../components/hero/heroTitle';
import { H1, H2 } from '../../primitives/appTitle';
import AppSection from '../../primitives/appSection';

import AppLinkBar from '../../primitives/appLinkBar';

import Usecase from '../../components/usecase';
import { FrontCommonMessages } from '../../appCommonTranslations';
import { ShText, useShIntlLocale } from '@shoootin/translations';
import MetierCoverTiles from './metierTiles';
import { Sticky, StickyContainer } from 'react-sticky';
import './frontMetier.less';
import MetierPhotoSection from './metierPagePhoto';
import MetierScanSection from './metierPageScan';
import MetierVideoSection from './metierPageVideo';
import {
  getMainProfessionUsecaseOfLocale,
  getVideoOfLocale,
  ProfessionData,
  ProfessionShootingType,
} from '../../appConstants';
import useProfessionHeaderImages from '../../queries/useProfessionHeaderImages';
// import useProfessionIntroImages from '../../queries/useProfessionIntroImages';
import { useMetierPageOffersLoader } from './metierPageOffers';
import { LinkData } from '../../appTypes';
import { isBrowser } from '../../utils/gatsbyUtils';
import { getProfessionMessage } from '../../appMessageDefinitions';
import useProfessionVideos from '../../queries/useVideos';
import useHomeProfessionGalleries from '../home/queries/useHomeProfessionGalleries';

const MetierInNav: LinkData[] = [
  { label: FrontCommonMessages.professionNav1, href: '#intro' },
  { label: FrontCommonMessages.professionNav2, href: '#offers' },
  { label: FrontCommonMessages.professionNav3, href: '#usecase' },
];

const getStickyStyle = (isSticky: boolean) => {
  if (isBrowser()) {
    const elHeader = document && document.querySelector('#header');
    if (elHeader) {
      return isSticky
        ? {
            top:
              elHeader.getClientRects()[0].height +
              elHeader.getClientRects()[0].top,
            transform: 'translateY(-4px)',
            width: '100%',
            left: '0',
            right: '0',
            zIndex: 3,
          }
        : {};
    }
  }
  return {};
};

const MetierPage = ({ profession }: { profession: ProfessionShootingType }) => {
  const locale = useShIntlLocale();
  const { pageName, mainUsecases, scanId, otherProfessions } = ProfessionData[
    profession
  ];
  // const photos = getPhotoGalleryOfLocale(profession, locale);

  const allPhotos = useHomeProfessionGalleries(true, locale);
  const professionPhotos = allPhotos[profession];

  const videoLocale = useProfessionVideos()[
    getVideoOfLocale(profession, locale)
  ];
  const heroImage = useProfessionHeaderImages()[profession];
  // const introImage = useProfessionIntroImages()[profession];
  const localeUsecase = getMainProfessionUsecaseOfLocale(mainUsecases, locale);

  const offers = useMetierPageOffersLoader(profession);

  return (
    <MainLayout className="page-metier" pageName={pageName}>
      <HeroTitle imgSrc={heroImage}>
        <H1 className="hero-title">
          <ShText message={getProfessionMessage(profession, 'title')} />
        </H1>
      </HeroTitle>
      <div
        className="container section"
        css={{ marginTop: '5em', textAlign: 'center' }}
      >
        <p className="text-intro">
          <ShText
            message={getProfessionMessage(profession, 'fullDescription')}
          />
        </p>
      </div>

      <StickyContainer>
        <AppSection className="metier-intro" id="intro">
          <Sticky>
            {({ style, isSticky }) => {
              const stickyStyle = getStickyStyle(isSticky);
              return (
                <nav
                  id="linknav"
                  className={isSticky ? 'fixed' : ''}
                  style={{
                    ...style,
                    ...stickyStyle,
                  }}
                >
                  <AppLinkBar
                    links={MetierInNav}
                    scroll
                    modifier="swiper-container-horizontal swiper-container-free-mode"
                  />
                </nav>
              );
            }}
          </Sticky>

          {/* {values.videoImg && ( */}
          {/* <div className="metier-video"> */}
          {/* <div className="metier-video__cover"> */}
          {/* <> */}
          {/* <Cover */}
          {/* path={values.videoImg} */}
          {/* onClick={() => setVideoId(values.videoId)} */}
          {/* mode={'video'} */}
          {/* /> */}
          {/* <VideoModal */}
          {/* videoId={videoId} */}
          {/* onClose={() => setVideoId(undefined)} */}
          {/* /> */}
          {/* </> */}
          {/* </div> */}
          {/* </div> */}
          {/* )} */}
          {/* {introImage && (
            <div className="metier-video">
              <div className="metier-video__cover">
                <CoverPhotoGatsbyImage fluid={introImage} />
              </div>
            </div>
            // <div className="metier-photo-intro">
            //   <div className="metier-photo-intro__cover">
            //     <img src={values.introImg} />
            //   </div>
            // </div>
          )} */}
        </AppSection>

        <MetierPhotoSection
          profession={profession}
          photos={professionPhotos}
          offers={offers}
        />

        <MetierVideoSection
          profession={profession}
          video={videoLocale}
          offers={offers}
        />

        <MetierScanSection
          profession={profession}
          scanId={scanId}
          offers={offers}
        />

        <AppSection
          className="section-usecase"
          id="usecase"
          header={
            <H2>
              <ShText message={FrontCommonMessages.usecase} />
            </H2>
          }
        >
          <Usecase name={localeUsecase} />
        </AppSection>
      </StickyContainer>

      <AppSection
        className="darker"
        header={
          <H2>
            <ShText message={FrontCommonMessages.professionAdapt} />
          </H2>
        }
      >
        <MetierCoverTiles professions={otherProfessions} />
      </AppSection>

      {/* <MetierCart /> */}
    </MainLayout>
  );
};

export default MetierPage;
